<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 {{ $t('rename_category') }}
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.pa-8
      .text-sm.font-semibold.neutral500--text.mb-2 {{ $t('category_name') }}
      v-text-field.round-xl.mb-4.text-md(v-model="categoryName" :placeholder="$t('enter_category_name')" outlined hide-details)
    v-divider

    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="save" :loading="isLoading" color="primary" depressed :disabled="categoryName.trim().length  === 0") {{ $t('save') }}

</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RenameCategoryDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    isLoading: false,
    categoryName: '',
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.categoryName = this.category.name
  },
  methods: {
    ...mapActions(['showMessage']),
    save () {
      this.isLoading = true
      this.axios.patch(`/product_categories/${this.category.id}`, { name: this.categoryName.trim() })
        .then(() => {
          this.showDialog = false
          this.$emit('edited')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
